export default {
  updateUuid: (state, payload) => (state.uuid = payload),
  updateIsEditing: (state, payload) => (state.isEditing = payload),
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updatStepNameRoutes: (state, payload) => (state.stepNameRoutes = payload),
  updateOptionsStates: (state, payload) => (state.optionsStates = payload),
  updateFilterChain: (state, payload) => (state.filter.chain = payload),
  updateFilterPos: (state, payload) => (state.filter.pos = payload),
  updateFilterAreasCode: (state, payload) => (state.filter.areasCode = payload),
  updateFilterUF: (state, payload) => (state.filter.uf = payload),
  updateFilterCity: (state, payload) => (state.filter.city = payload),
  updateFilterStatus: (state, payload) => (state.filter.status = payload),
  updatePos: (state, payload) => (state.pos = { ...state.pos, ...payload }),
  setPos: (state, payload) => (state.pos = payload),
  setAllRolesList: (state, payload) => (state.allRolesList = payload),
  clearPosStore: (state, payload) => {
    state.pos = {}
    state.isEditing = false
    state.uuid = ""
    state.currentStep = 0
    state.allRolesList = []
  }
}
